import React from 'react';
import 'leaflet/dist/leaflet.css';
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getSession} from "../../services/Session/reducer";
import {RootState} from "../../../reducers";
import {ReactComponent as CarSVG} from "../../../images/icons/car.svg";
import {getCart} from "../../services/Cart/reducer";
import Money from "../Common/Money";
import {getCartPrice, getFreeDeliveryPrice, getToFreeDeliveryPrice} from "../../utils/cart";

type Props = ReturnType<typeof mapStateToProps>;

const CartDeliveryInfoComponent = (props: Props) => {
    const {t} = useTranslation();
    const freeDeliveryPrice = getFreeDeliveryPrice(props.session);

    if (props.cart.type !== "DELIVERY" || !props.session.in_delivery_area || freeDeliveryPrice === undefined) return null;

    const toFreeDeliveryPrice = getToFreeDeliveryPrice(props.session, props.cart);
    const percent = toFreeDeliveryPrice > 0 ? getCartPrice(props.cart) / freeDeliveryPrice : 100;

    return (
        <div className={"cart-progress text-success"}>
            <div className="progress" role="progressbar" aria-valuenow={0}
                 aria-valuemin={0} aria-valuemax={100}>
                <div className={`progress-bar${toFreeDeliveryPrice <= 0 ? " bg-success" : ""}`}
                     style={{width: `${percent * 100}%`}}/>
            </div>
            <div className={`cart-progress-info${toFreeDeliveryPrice <= 0 ? " text-success" : ""}`}>
                <CarSVG className="me-1"/>
                {toFreeDeliveryPrice <= 0 ? (
                    <div>
                        {t("modules.cart.field.free_delivery.title")}
                    </div>
                ) : (
                    <div>
                        {`${t("modules.cart.field.amount_to_free_delivery.title")}: `}
                        <strong>
                            <Money value={toFreeDeliveryPrice}/>
                        </strong>
                    </div>
                )}
            </div>
        </div>
    )
};


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    cart: getCart(state.cart)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartDeliveryInfoComponent));
